import React, { useContext } from "react";
import {
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { AuthContext } from "../store/auth-context";

const UserLogin = () => {
  const ctx = useContext(AuthContext);
  const { accounts } = useMsal();
  const userAccount = accounts[0] || {};

  return (
    <>
      <AuthenticatedTemplate>
        <UncontrolledDropdown className="ms-auto">
          <DropdownToggle nav caret>
            {userAccount.name}
          </DropdownToggle>
          <DropdownMenu right>
            <h5 className="dropdown-item-text mb-0">{userAccount.name}</h5>
            <p className="dropdown-item-text text-muted mb-0">
              {userAccount.username}
            </p>
            <DropdownItem divider />
            <DropdownItem onClick={ctx.onSignOut}>Sign Out</DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <NavItem className="margin-left-auto">
          <NavLink className="text-light" onClick={ctx.onSignIn} href="#">
            Sign in
          </NavLink>
        </NavItem>
      </UnauthenticatedTemplate>
    </>
  );
};

export default UserLogin;
